import { render, staticRenderFns } from "./TrelloColumnHeader.vue?vue&type=template&id=4f73e3ce&scoped=true&"
import script from "./TrelloColumnHeader.vue?vue&type=script&lang=js&"
export * from "./TrelloColumnHeader.vue?vue&type=script&lang=js&"
import style0 from "./TrelloColumnHeader.vue?vue&type=style&index=0&id=4f73e3ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f73e3ce",
  null
  
)

export default component.exports